import React from 'react';
import './slot-machine/slot-machine.scss';

interface Token {
    image: string;
    name: string;
    symbol: string;
    amount: number;
}

interface WinProps {
    tx: string;
    date: string;
    tokens: Token[];
}

const Win: React.FC<WinProps> = ({ tx, date, tokens }) => (
    <div className="win">
        <div>
            Date: {date}<br />
            TX: <a href={`https://solscan.io/tx/${tx}`} target="_blank" rel="noopener noreferrer">
                {tx.substring(0, 6)}...{tx.substring(tx.length - 4)}
            </a>
        </div>
        {tokens.map((token, index) => (
            <div key={index} className="token">
                <div className="token-row">
                    <img src={token.image} alt={token.name} title={token.name} />
                    <span className="token-symbol">{token.symbol}</span>
                    <span className="token-amount">
                        {token.amount > 100000
                            ? Math.floor(token.amount / 10000) * 10000
                            : token.amount > 1000
                            ? token.amount.toLocaleString()
                            : token.amount < 10
                            ? token.amount.toFixed(3)
                            : token.amount}
                    </span>
                </div>
            </div>
        ))}
        <hr />
    </div>
);

export default Win;